import api from './api.js';

export const communicationService = {
  // Announcements
  getAnnouncements: (params = {}) => api.get('/communication/announcements', { params }),
  getAnnouncement: (id) => api.get(`/communication/announcements/${id}`),
  createAnnouncement: (data) => api.post('/communication/announcements', data),
  updateAnnouncement: (id, data) => api.put(`/communication/announcements/${id}`, data),
  deleteAnnouncement: (id) => api.delete(`/communication/announcements/${id}`),
  
  // Messages
  getMessages: (params = {}) => api.get('/communication/messages', { params }),
  getMessage: (id) => api.get(`/communication/messages/${id}`),
  sendMessage: (data) => api.post('/communication/messages', data),
  getMessageThread: (id) => api.get(`/communication/messages/${id}/thread`),
  markAsRead: (id) => api.put(`/communication/messages/${id}/read`),
  deleteMessage: (id) => api.delete(`/communication/messages/${id}`),
  
  // Notifications
  getNotifications: (params = {}) => api.get('/communication/notifications', { params }),
  markNotificationRead: (id) => api.put(`/communication/notifications/${id}/read`),
  markAllAsRead: () => api.put('/communication/notifications/mark-all-read'),
  deleteNotification: (id) => api.delete(`/communication/notifications/${id}`),
  
  // Search messages
  searchMessages: (query, params = {}) => 
    api.get('/communication/messages/search', { 
      params: { ...params, q: query } 
    }),
  
  // Get conversation participants
  getConversationParticipants: (conversationId) => 
    api.get(`/communication/conversations/${conversationId}/participants`),
  
  // Get user conversations
  getUserConversations: (params = {}) => 
    api.get('/communication/conversations', { params }),
};

